
import { useEffect, useState } from "react";

// ROUTER
import { Link, useParams } from 'react-router-dom';

// PICTURES
import BackroundPic from "../pictures/productiondes.webp";
import Listapic from "../pictures/lista.png";

// HELPING FUNCTIONS
import { loadAllImages, getHeight } from "../functions/HelpingFunctions";

// COMPONENTS
import BackBtn from "./BackBtn";

export default function ProductionDesContent({ thisData }) {

    // ROUTER
    const params = useParams()

    // STATES
    const [allImagesLoaded, setAllImagesLoaded] = useState("0");
    const imageUrls = [BackroundPic];

    // SCALING
    const [scale, setScale] = useState(1);

    function changeScale() {
        setScale(getHeight());
    }

    // SCALE AFTER LOAD
    useEffect(() => {
        changeScale()
    }, [])

    // CHANGE SCALE ON RESIZE
    useEffect(() => {
        window.addEventListener("resize", changeScale);

        return() => {
            window.removeEventListener("resize", changeScale);
        }
    }, [])

    //WAIT TO LOAD ALL IMAGES
    useEffect(() => {
        async function loadImages() {
            try{
                const loadingState =  await loadAllImages(imageUrls);
                setAllImagesLoaded(loadingState);
            }
            catch(err) {
                console.log(err)
            }
        }
        loadImages()
        
        // eslint-disable-next-line
    }, []);

    return(
        <>
        <div 
        style={{
            opacity: allImagesLoaded,
            transition: "1s",
        }}
        >         
            <div className="flex-col align-center">
                <div 
                style={{
                    transform: "scale(" + scale + ")",
                    transformOrigin: "top",
                }}
                className="background-pic flex-col align-center">
                    <img width={2311.5} height={1300} src={BackroundPic}></img>
                </div>


                <div className="content-container"
                style={{
                    transform: "scale(" + scale + ")",
                    transformOrigin: "top",
                }}>

                    <div
                    style={{
                        transform: "translate(-57px, 36px)"
                    }}>
                        <BackBtn />
                    </div>
                    

                    <div
                    style={{
                        transform: "translate(-550px, 420px)",
                        position: "absolute", 
                        
                    }}
                    >
                        <img style={{scale: "0.9"}} src={Listapic}></img>
                    </div>

                    <div
                    style={{
                        transform: "translate(-552px, 418px)",
                        position: "absolute", 
                        width: "500px",
                        textAlign: "center"
                    }}
                    >
                        <span className="menu-text-2">*{thisData?.nazev}</span>
                    </div>

                    <Link 
                        to={"/client/" + params.id + "/production-design/mood-1"}

                        style={{
                            transform: "translate(-723px, 66px)",
                            position: "absolute", 
                            width: "230px",
                        }}
                        className="production-text-container-2"
                        >
                        <span className="production-menu-text-2">MOOD 1</span>
                    </Link>

                    <Link 
                        to={"/client/" + params.id + "/production-design/mood-2"}

                        style={{
                            transform: "translate(-410px, 66px)",
                            position: "absolute", 
                            width: "230px"
                        }}
                        className="production-text-container-2"
                        >
                        <span className="production-menu-text-2">MOOD 2</span>
                    </Link>

                    <Link 
                        to={"/client/" + params.id + "/production-design/mood-revised"}

                        style={{
                            transform: "translate(-97px, 215px)",
                            position: "absolute", 
                            width: "190px"
                        }}
                        className="production-text-container-2"
                        >
                        <span className="production-menu-text-2">MOOD</span>
                        <span style={{marginTop: "-7px"}} className="production-menu-text-2">REVISED</span>
                    </Link>

                    <Link 
                        to={"/client/" + params.id + "/production-design/actual-props"}

                        style={{
                            transform: "translate(200px, 215px)",
                            position: "absolute", 
                            width: "190px"
                        }}
                        className="production-text-container-2"
                        >
                        <span className="production-menu-text-2">ACTUAL</span>
                        <span style={{marginTop: "-7px"}} className="production-menu-text-2">PROPS</span>
                    </Link>


                    <Link 
                        to={"/client/" + params.id + "/production-design/design"}

                        style={{
                            transform: "translate(485px, 135px)",
                            position: "absolute", 
                            width: "175px"
                        }}
                        className="production-text-container-2"
                        >
                        <span className="production-menu-text-2">DESIGN</span>
                    </Link>


                    <Link 
                        to={"/client/" + params.id + "/production-design/director-selection"}

                        style={{
                            transform: "translate(763px, 145px)",
                            position: "absolute", 
                            width: "190px"
                        }}
                        className="production-text-container-2"
                        >
                        <span className="production-menu-text-2">DIRECTOR</span>
                        <span style={{marginTop: "-7px"}} className="production-menu-text-2">SELECTION</span>
                    </Link>


                    <div className="production-container" >
                        <Link 
                        to={"/client/" + params.id + "/locations"}
                        className="production-text-container"
                        >
                            <span className="locations-menu-text">LOCATIONS</span>
                        </Link>

                        <Link 
                        to={"/client/" + params.id + "/wardrobe"}
                        className="production-text-container"
                        >
                            <span className="locations-menu-text">WARDROBE</span>
                        </Link>

                        <Link 
                        to={"/client/" + params.id + "/casting"}
                        className="production-text-container"
                        >
                            <span className="locations-menu-text">CASTING</span>
                        </Link>
                    </div>

                </div>
            </div>
        </div>
        </>
    )
}